import React, { useEffect, useState, useRef } from 'react'
import Nlayout from './Nlayout'
import { Alert, Box, Button, CircularProgress, Grid, Link, Paper, Step, StepLabel, Stepper, TextField, Typography, styled } from '@mui/material'
import { Dialog } from "@mui/material";
import { FaCloudUploadAlt } from "react-icons/fa";

import backgroundImg from './main_intro.jpg'
import axios from 'axios'
import TelegramVerificationCard from './components/TelegramVerificationCard';
import TelegramVerificationModal from './components/TelegramVerificationModal';
import { fetchTelegramStatus, getLocalTelegramData } from './services/telegramService';

import paso1 from './img/bonus1x.jpeg'

import paso2 from './Paso2-gif.gif'
import paso3 from './Paso3-gif.gif'
import vault from './vault.jpg'
import ej2 from './ejpaso2.jpg'
import ej3 from './ejpaso3.jpg'
import successImg from './withdraw.jpg'

import paso1bono from './img/paso1.jpeg'
import paso2bono from './img/paso2.jpeg'
import paso3bono from './img/paso3.jpeg'
import paso4bono from './img/paso4.jpeg'
import paso5bono from './img/paso5.jpeg'
import { BrowserQRCodeReader } from '@zxing/browser'
import coinImg from './Wild_coin.png';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const StepWrapper = ({ images, instruction, children }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, height: '100%', justifyContent: 'space-between' }}>
            {images && (
                <Box
                    sx={{
                        flex: '0 0 230px',
                        height: '230px',
                        background: 'linear-gradient(135deg, #060e1f 0%, #0a1628 100%)',
                        borderRadius: '12px',
                        border: '1px solid #1a3260',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 1.5,
                        width: '80%',
                        margin: '0 auto',
                        position: 'relative',
                        boxShadow: 'inset 0 0 25px rgba(0,0,0,0.8), 0 4px 12px rgba(0,0,0,0.5)',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            top: 0, right: 0, bottom: 0, left: 0,
                            background: 'radial-gradient(circle, transparent 40%, rgba(0,0,0,0.4) 100%)',
                            pointerEvents: 'none',
                        },
                        '& img': {
                            height: '100%',
                            width: 'auto',
                            maxHeight: '100%',
                            maxWidth: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                        }
                    }}
                >
                    {images}
                </Box>
            )}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                {instruction && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 2,
                            backgroundColor: 'rgba(59, 130, 246, 0.08)',
                            p: 2,
                            borderRadius: '10px',
                            border: '1px solid rgba(59, 130, 246, 0.12)',
                            borderLeftWidth: '4px',
                            borderLeftColor: '#3b82f6',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        }}
                    >
                        <Box
                            sx={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                backgroundColor: '#1d4ed8',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                            }}
                        >
                            i
                        </Box>
                        <Box sx={{ flex: 1 }}>{instruction}</Box>
                    </Box>
                )}
                {children}
            </Box>
        </Box>
    );
};


function Verificar1xBet(props) {
    const [userEmail, setUserEmail] = useState('');
    const mailKick = localStorage.getItem('kick_mail')
    const [solicitudes, setSolicitudes] = useState()
    const [cargar, setCargar] = useState()
    const nombre = localStorage.getItem('kick_user')
    const [isWinner, setIsWinner] = useState()
    // Estados para el modal
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [triggerUpload, setTriggerUpload] = useState(null);
    const checkWinner = async () => {
        setCargar(true)
        const peticion = await axios.post(`https://backend.eldenguee.com/sorteo/check-ganador`, { nombre })
        const peticionTipeo = await axios.post(`https://backend.eldenguee.com/solicitudes/tipeo`, { nombre })
        const soli = peticionTipeo?.data?.map((p) => p.verificar1xBet)
        setSolicitudes(soli)
        setIsWinner(peticion?.data)
        setUserEmail(mailKick)
        setTimeout(() => {
            setCargar(false)
        }, 3000);
        setCargar(false)

    }


    useEffect(() => { checkWinner() }, [])

    const [activeStep, setActiveStep] = useState(0);
    const [offerScreenshot, setOfferScreenshot] = useState(null);
    const [bnbScreenshot, setBnbScreenshot] = useState(null);
    const [bnbAddress, setBnbAddress] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const isSubmittingRef = useRef(false);
    const [success, setSuccess] = useState(false);
    const [offerScreenshotUrl, setOfferScreenshotUrl] = useState('');
    const [bnbScreenshotUrl, setBnbScreenshotUrl] = useState('');
    const [url, setUrl] = useState('')
    const steps = ['Paso 1'];


    const handleNext = () => {
        if (validateStep()) {
            setError('');
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleBack = () => {
        setError('');
        setActiveStep((prev) => prev - 1);
    };

    const validateStep = () => {



        return true;
    };

    const [deshabilitarBoton, setDeshabilitarBoton] = useState(false)
    // ==================== NUEVA FUNCIÓN DE SUBIDA (Proxy) ====================
    const uploadToServer = async (file) => {
        if (!file || !(file instanceof File)) {
            throw new Error('Archivo inválido');
        }

        const formData = new FormData();
        formData.append('imagen', file);   // ← Nombre del campo que espera tu backend

        const response = await fetch('https://backend.eldenguee.com/solicitudes/upload', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || 'Error al subir la imagen');
        }

        const data = await response.json();
        return data.url || data.fileUrl || data.filename; // Ajusta según lo que devuelva tu backend
    };
    const getPublicIP = async () => {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data.ip;
    };
    const [telegramModalOpen, setTelegramModalOpen] = useState(false);
    const [tgStatus, setTgStatus] = useState(null);

    useEffect(() => {
        if (!nombre) return;
        const cached = getLocalTelegramData(nombre);
        if (cached) setTgStatus(cached);

        fetchTelegramStatus(nombre).then(data => {
            if (data) setTgStatus(data);
        }).catch(err => console.error('Error obteniendo estado Telegram:', err));
    }, [nombre]);

    const isTelegramVerified = Boolean(tgStatus?.verified || tgStatus?.isVerified);

    const handleRequestTipeo = async () => {
        if (isSubmittingRef.current || loading || deshabilitarBoton) return;
        isSubmittingRef.current = true;
        setDeshabilitarBoton(true);
        setLoading(true);
        setError('');

        const userKick = nombre || localStorage.getItem('kick_user');
        if (!userKick || userKick === 'null' || userKick === 'undefined') {
            setError('⚠️ Debes iniciar sesión con tu cuenta de Kick antes de enviar la solicitud.');
            isSubmittingRef.current = false;
            setDeshabilitarBoton(false);
            setLoading(false);
            return;
        }

        // Verificar Telegram obligatoriamente antes de reclamar
        const tgStatus = await fetchTelegramStatus(userKick);
        if (!tgStatus || (!tgStatus.verified && !tgStatus.isVerified)) {
            setError('⚠️ Debes verificar tu cuenta de Telegram y número de celular antes de reclamar.');
            setTelegramModalOpen(true);
            isSubmittingRef.current = false;
            setDeshabilitarBoton(false);
            setLoading(false);
            return;
        }

        const ip = await getPublicIP();
        try {

            if (!bnbScreenshotUrl) {
                throw new Error('Todos los campos son obligatorios');
            }
            setDeshabilitarBoton(true)
            // Enviar solicitud al backend proxy
            const response = await fetch('https://backend.eldenguee.com/solicitudes/submit-request-bonus-verificar', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nombre: userKick,
                    bnbAddress,
                    bnbScreenshot: bnbScreenshotUrl,
                    ip,
                    email: mailKick
                }),
            });

            console.log('response', response)
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al enviar la solicitud');
            }

            setSuccess(true);
        } catch (err) {
            setError('Error: ' + err.message);
        } finally {
            isSubmittingRef.current = false;
            setLoading(false);
            setDeshabilitarBoton(false);
        }
    };
    const [isUploading, setIsUploading] = useState(false);



    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openImage = (url) => {
        setSelectedImage(url);
        setIsOpen(true);
    };

    const closeImage = () => {
        setIsOpen(false);
        setSelectedImage(null);
    };
    // Manejar cambio de archivo y subir a Cloudinary
    const handleFileChange = (setFile, setUrl) => async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFile(file);
            try {
                setIsUploading(true);
                const url = await uploadToServer(file);
                setUrl(url);
                setError('');
            } catch (err) {
                setError('Error al subir la imagen: ' + err.message);
            } finally {
                setIsUploading(false);
            }
        }
    };
    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <StepWrapper
                        images={<img src={paso1} alt="Paso 1" onClick={() => openImage(paso1)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Box sx={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.5' }}>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Subí la captura del depósito realizado en <span style={{ color: '#38bdf8', fontWeight: 'bold' }}>1XBET</span>.
                                </Typography>
                                <Typography paragraph sx={{ mb: 0 }}>
                                    La imagen debe incluir la fecha y hora de carga visible para poder verificarlo correctamente y habilitar la acreditación de{' '}
                                    <span
                                        style={{
                                            background: 'rgba(0, 255, 115, 0.1)',
                                            color: '#00ff73',
                                            border: '1px solid rgba(0, 255, 115, 0.3)',
                                            padding: '3px 10px',
                                            borderRadius: '99px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            fontWeight: 'bold',
                                            fontSize: '0.85rem',
                                            verticalAlign: 'middle',
                                            boxShadow: '0 0 8px rgba(0, 255, 115, 0.2)',
                                        }}
                                    >
                                        <img src={coinImg} style={{ width: 14, height: 14 }} alt="Coin" />
                                        1000 D-COINS
                                    </span>.
                                </Typography>
                            </Box>
                        }
                    >
                        <Box
                            sx={{
                                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                borderRadius: 2,
                                p: 1.5,
                                color: '#fca5a5',
                                border: '1px dashed #ef4444',
                                mb: 1.5,
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                Importante: La imagen debe ser tomada el mismo día en que se realiza la solicitud y debe enviarse completa, sin recortes ni modificaciones. En caso de no cumplir con estos requisitos, la solicitud será rechazada por el sistema.
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                backgroundColor: 'rgba(59, 130, 246, 0.06)',
                                borderRadius: 2,
                                p: 1.5,
                                color: '#cbd5e1',
                                border: '1px dashed #1e3a6e',
                            }}
                        >
                            <Box
                                sx={{
                                    borderBottom: '1px solid #1e3a6e',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    pb: 1,
                                    mb: 1,
                                    fontWeight: 'bold',
                                }}
                            >
                                <Typography variant="body2">Tu imagen</Typography>
                                <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                                    {bnbScreenshot ? `Archivo: ${bnbScreenshot.name}` : 'No hay archivo'}
                                </Typography>
                            </Box>
                            {isUploading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px' }}>
                                    <CircularProgress size={24} color="inherit" />
                                </Box>
                            ) : (
                                bnbScreenshotUrl && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                        <img src={bnbScreenshotUrl} style={{ maxHeight: '60px', maxWidth: '100%', borderRadius: '4px', cursor: 'pointer' }} alt="Preview" onClick={() => openImage(bnbScreenshotUrl)} />
                                    </Box>
                                )
                            )}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                component="label"
                                variant="contained"
                                startIcon={<FaCloudUploadAlt />}
                                sx={{
                                    backgroundColor: '#1e3a6e',
                                    color: '#fff',
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    '&:hover': { backgroundColor: '#2d5aa0' },
                                }}
                                onClick={() => {
                                    setTriggerUpload(() => () =>
                                        document.getElementById('bnbScreenshotInput').click()
                                    );
                                    setShowWarningModal(true);
                                }}
                            >
                                Cargar imagen
                            </Button>
                            <VisuallyHiddenInput
                                id="bnbScreenshotInput"
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange(setBnbScreenshot, setBnbScreenshotUrl)}
                            />
                            <Button
                                variant="contained"
                                onClick={handleRequestTipeo}
                                disabled={deshabilitarBoton}
                                sx={{
                                    backgroundColor: '#3b82f6',
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    '&:hover': { backgroundColor: '#2563eb' },
                                    '&:disabled': { backgroundColor: '#1a2f5a', color: '#60a5fa' },
                                }}
                            >
                                {deshabilitarBoton ? 'Enviando...' : 'Terminar →'}
                            </Button>
                        </Box>
                    </StepWrapper>
                );
            default:
                return null;
        }
    };


    const redirectHome = () => {
        window.location.href = '/'
    }
    return (
        <Nlayout>
            <Grid style={{ background: '#11111d', width: '100%' }}>

                {
                    cargar ?
                        <Grid className='mt-bg-fondo' style={{

                            height: '980px',
                            backgroundColor: '#3f3d45',
                            margin: '0 auto',
                            position: 'relative',
                            backgroundPosition: '50%'
                        }}>
                            <Grid className='container' style={{
                                padding: 50,
                                gap: '10px',
                                justifyContent: 'center',

                            }}>
                                <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>
                                    <Typography style={{ color: 'white', fontWeight: 'bold', fontSize: '32px', fontFamily: 'Outfit,sans-serif' }} >
                                        eldenguee.com
                                    </Typography>
                                    <Typography sx={{
                                        background: 'linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontWeight: 'bold',
                                        fontSize: props.isMobile ? 32 : 65,
                                        fontFamily: 'Belerofonte'
                                    }} >Verificando..</Typography>
                                </Grid>

                                <Grid style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >

                                </Grid>
                            </Grid>
                        </Grid>

                        :

                        solicitudes < 1 ?

                            <Grid className='mt-bg-fondo' style={{

                                height: '980px',
                                backgroundColor: '#3f3d45',
                                margin: '0 auto',
                                position: 'relative',
                                backgroundPosition: '50%'
                            }}>
                                <Grid className='container' style={{
                                    padding: 50,
                                    gap: '10px',
                                    justifyContent: 'center',

                                }}>
                                    <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>
                                        <Typography style={{ color: 'white', fontWeight: 'bold', fontSize: '32px', fontFamily: 'Outfit,sans-serif', textAlign: 'center' }} >
                                            No estás habilitado para solicitar tipeo, lo tienes que ganar en algún sorteo realizado por el dengue!

                                        </Typography>
                                        <Typography sx={{
                                            background: 'linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            fontWeight: 'bold',
                                            fontSize: props.isMobile ? 32 : 50,
                                            fontFamily: 'Belerofonte'
                                        }} >Eldenguee.com</Typography>
                                    </Grid>

                                    <Grid style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >


                                        <Button

                                            sx={{
                                                color: 'black',
                                                fontWeight: 'bold',
                                                padding: '0.75rem 2rem',
                                                fontSize: '.8rem',
                                                fontFamily: 'Outfit,sans-serif',
                                                backgroundImage: `linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)`,
                                                border: '2px solid #e0c060',
                                                borderRadius: '100px',
                                                boxShadow: '0 0 8px rgba(118, 118, 245, 0.8)',
                                                textTransform: 'uppercase',
                                                transition: 'all 0.3s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 0 16px rgba(118, 118, 245, 1)',
                                                    transform: 'scale(1.05)',
                                                },
                                            }}
                                            href='/'
                                        >
                                            Volver al inicio
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            :

                            <Grid className='mt-bg-fondo' style={{

                                height: '980px',
                                backgroundColor: '#3f3d45',
                                margin: '0 auto',
                                position: 'relative',
                                backgroundPosition: '50%',
                                marginTop: props.isMobile ? '1%' : '2%'
                            }}>
                                <Grid className='container' style={{
                                    padding: props.isMobile ? 10 : 50,
                                    gap: '10px',
                                    justifyContent: 'center',

                                }}>
                                    <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>


                                    </Grid>

                                    <Box sx={{ mx: 'auto', my: 1, mt: '8%' }}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                maxWidth: !props.isMobile ? 650 : '100%',
                                                margin: '0 auto',
                                                borderRadius: success ? 'none' : '16px',
                                                overflow: 'hidden',
                                                backgroundColor: success ? 'transparent' : '#08142e',
                                                color: '#fff',
                                                p: props.isMobile ? 2 : 4,
                                                border: '1px solid #1a3260',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
                                            }}
                                        >
                                            {
                                                !success &&
                                                <>
                                                    {/* Header 1xBet */}
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#3b82f6" />
                                                                <path d="M14 2V8H20L14 2Z" fill="#1d4ed8" />
                                                                <path d="M16 12H8V14H16V12Z" fill="white" />
                                                                <path d="M16 16H8V18H16V16Z" fill="white" />
                                                                <path d="M11 8H8V10H11V8Z" fill="white" />
                                                            </svg>
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '1.25rem', fontFamily: 'Outfit, sans-serif' }}>
                                                                Verificar depósito 1xBet
                                                            </Typography>
                                                        </Box>
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            href="/guias"
                                                            startIcon={
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                    <circle cx="12" cy="12" r="10"></circle>
                                                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                                                                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                                                </svg>
                                                            }
                                                            sx={{
                                                                color: '#94a3b8',
                                                                borderColor: 'rgba(59, 130, 246, 0.2)',
                                                                borderRadius: '999px',
                                                                textTransform: 'none',
                                                                fontSize: '0.75rem',
                                                                py: 0.5,
                                                                px: 1.5,
                                                                backgroundColor: 'rgba(59, 130, 246, 0.06)',
                                                                '&:hover': {
                                                                    borderColor: 'rgba(59, 130, 246, 0.4)',
                                                                    backgroundColor: 'rgba(59, 130, 246, 0.12)',
                                                                }
                                                            }}
                                                        >
                                                            ¿Necesitas ayuda?
                                                        </Button>
                                                    </Box>

                                                    {/* Telegram Warning Cartel */}
                                                    {!isTelegramVerified && (
                                                        <Alert
                                                            severity="warning"
                                                            action={
                                                                <Button color="inherit" size="small" onClick={() => setTelegramModalOpen(true)} sx={{ fontWeight: 700, textTransform: 'none', bgcolor: 'rgba(0,0,0,0.2)' }}>
                                                                    Verificar Ahora
                                                                </Button>
                                                            }
                                                            sx={{
                                                                mb: 3,
                                                                borderRadius: '12px',
                                                                fontFamily: 'Outfit, sans-serif',
                                                                fontWeight: 700,
                                                                fontSize: '0.9rem',
                                                                color: '#FFF',
                                                                backgroundColor: 'rgba(255, 170, 0, 0.2)',
                                                                border: '1px solid rgba(255, 170, 0, 0.4)',
                                                                backdropFilter: 'blur(10px)'
                                                            }}
                                                        >
                                                            Para reclamar el tipeo necesitas verificar tu cuenta en Telegram.
                                                        </Alert>
                                                    )}

                                                    {/* Progress Bar 1xBet */}
                                                    <Box sx={{ mb: 4 }}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                            <Typography sx={{ fontSize: '0.9rem', color: '#cbd5e1', fontWeight: '500' }}>
                                                                Paso <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>{activeStep + 1}</span> de {steps.length}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '0.9rem', color: '#3b82f6', fontWeight: 'bold' }}>
                                                                {Math.round(((activeStep + 1) / steps.length) * 100)}%
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: '100%', height: '6px', backgroundColor: '#06102a', borderRadius: '999px', overflow: 'hidden', border: '1px solid #1a3260' }}>
                                                            <Box
                                                                sx={{
                                                                    width: `${((activeStep + 1) / steps.length) * 100}%`,
                                                                    height: '100%',
                                                                    backgroundColor: '#3b82f6',
                                                                    borderRadius: '999px',
                                                                    transition: 'width 0.4s ease-in-out',
                                                                    boxShadow: '0 0 8px rgba(59, 130, 246, 0.7)',
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </>
                                            }

                                            {success ? (
                                                <Box
                                                    sx={{
                                                        backgroundColor: '#0c1b26',
                                                        borderRadius: '12px',
                                                        padding: 3,
                                                        width: '80%',
                                                        margin: '0 auto',
                                                        textAlign: 'center',
                                                        color: 'white',
                                                    }}
                                                >
                                                    {/* Título con ícono y botón cerrar */}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Typography sx={{ fontWeight: 'bold' }}>Verificación de deposito</Typography>
                                                        <Button sx={{ color: 'white' }} size="small">✕</Button>
                                                    </Box>

                                                    {/* Imagen */}
                                                    <Box sx={{ mb: 2 }}>
                                                        <img
                                                            src={successImg}// Colocá la ruta correcta a tu imagen
                                                            alt="Caja fuerte"
                                                            style={{ width: '100%', height: 'auto', margin: '0 auto' }}
                                                        />
                                                    </Box>

                                                    {/* Mensaje principal */}
                                                    <Typography sx={{ fontSize: '1.2rem', fontWeight: 'bold', mb: 2 }}>
                                                        ¡Se completó tu verificación de deposito!
                                                    </Typography>

                                                    {/* Cuadro con correo */}
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            backgroundColor: '#15232f',
                                                            color: 'white',
                                                            padding: 2,
                                                            borderRadius: '8px',
                                                            mb: 3,
                                                        }}
                                                        style={{ border: '2px dashed #2a2e38' }}
                                                    >
                                                        <Typography sx={{ fontSize: '0.9rem', textAlign: 'left' }}>
                                                            Cuando te llegue el correo confirmando la verificación obtendras tus 1000 D-COINS!
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 'bold', mt: 1, textAlign: 'left' }}>
                                                            {userEmail}
                                                        </Typography>
                                                    </Paper>

                                                    {/* Botón */}
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: '#007bff',
                                                            borderRadius: '8px',
                                                            textTransform: 'none',
                                                            fontWeight: 'bold',
                                                            '&:hover': {
                                                                backgroundColor: '#0066d6',
                                                            },
                                                        }}
                                                        onClick={redirectHome}
                                                    >
                                                        Listo
                                                    </Button>
                                                </Box>
                                            ) : (
                                                <>
                                                    {error && (
                                                        <Alert severity="error" sx={{ mb: 2 }}>
                                                            {error}
                                                        </Alert>
                                                    )}
                                                    <Box
                                                        sx={{
                                                            minHeight: props.isMobile && 650, // ajustá estos valores
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        {getStepContent(activeStep)}
                                                    </Box>
                                                    {isOpen && selectedImage && (
                                                        <div
                                                            style={{
                                                                position: 'fixed',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100vw',
                                                                height: '100vh',
                                                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                zIndex: 99999,
                                                            }}
                                                        >
                                                            {/* Botón X para cerrar */}
                                                            <button
                                                                onClick={closeImage}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 20,
                                                                    right: 20,
                                                                    background: 'transparent',
                                                                    border: 'none',
                                                                    fontSize: '32px',
                                                                    color: '#fff',
                                                                    cursor: 'pointer',
                                                                    zIndex: 99999,
                                                                }}
                                                                aria-label="Cerrar visor"
                                                            >
                                                                &times;
                                                            </button>

                                                            {/* Imagen ampliada */}
                                                            <img
                                                                src={selectedImage}
                                                                alt="Expanded"
                                                                style={{
                                                                    maxWidth: '90%',
                                                                    maxHeight: '90%',
                                                                    borderRadius: 10,
                                                                    boxShadow: '0 0 20px rgba(0,0,0,0.5)',
                                                                }}
                                                                onClick={(e) => e.stopPropagation()} // evita que se cierre al hacer click sobre la imagen
                                                            />
                                                        </div>
                                                    )}
                                                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                                                {
                                                    activeStep !== 0 &&
                                                    <Button
                                                        disabled={activeStep === 0 || loading}
                                                        onClick={handleBack}
                                                        variant="outlined"
                                                    >
                                                        Atrás
                                                    </Button>
                                                }

                                                <Button
                                                    onClick={activeStep === steps.length - 1 ? handleRequestTipeo : handleNext}
                                                    variant="contained"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <CircularProgress size={24} />
                                                    ) : activeStep === steps.length - 1 ? (
                                                        'Terminar solicitud'
                                                    ) : (
                                                        'Siguiente'
                                                    )}
                                                </Button> 
                                            </Box> */}
                                                </>
                                            )}
                                        </Paper>
                                    </Box>
                                </Grid>
                            </Grid>
                }

                <Dialog
                    open={showWarningModal}
                    onClose={() => setShowWarningModal(false)}
                    PaperProps={{
                        style: {
                            backgroundColor: '#0a1628',
                            color: 'white',
                            padding: '24px',
                            borderRadius: '16px',
                            textAlign: 'center',
                            maxWidth: '440px',
                            border: '1px solid #1e3a6e',
                            boxShadow: '0 12px 32px rgba(0,0,0,0.7)',
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(239, 68, 68, 0.15)',
                                color: '#ef4444',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '1.6rem',
                                border: '1px solid rgba(239, 68, 68, 0.3)',
                            }}
                        >
                            ⚠️
                        </Box>

                        <Typography sx={{ fontWeight: 'bold', fontSize: '1.15rem', color: '#f8fafc' }}>
                            Requisito importante de la imagen
                        </Typography>

                        <Box
                            sx={{
                                backgroundColor: 'rgba(239, 68, 68, 0.08)',
                                border: '1px dashed rgba(239, 68, 68, 0.35)',
                                borderRadius: '10px',
                                p: 2,
                                textAlign: 'left',
                                width: '100%',
                                boxSizing: 'border-box',
                                my: 1,
                            }}
                        >
                            <Typography sx={{ fontSize: '0.9rem', color: '#cbd5e1', lineHeight: '1.6' }}>
                                • La captura debe ser <strong>tomada el día de hoy</strong>.<br />
                                • Debe enviarse <strong>completa, sin recortes ni modificaciones</strong>.<br /><br />
                                <span style={{ color: '#fca5a5' }}>
                                    De lo contrario, la solicitud <strong>será denegada automáticamente</strong>.
                                </span>
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, width: '100%', mt: 1 }}>
                            <Button
                                variant="outlined"
                                onClick={() => setShowWarningModal(false)}
                                sx={{
                                    flex: 1,
                                    borderColor: '#334155',
                                    color: '#94a3b8',
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    '&:hover': { borderColor: '#64748b', color: '#f1f5f9', backgroundColor: 'rgba(255,255,255,0.05)' },
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setShowWarningModal(false);
                                    if (triggerUpload) triggerUpload();
                                }}
                                sx={{
                                    flex: 1.3,
                                    backgroundColor: '#22c55e',
                                    color: '#052e16',
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    boxShadow: '0 0 12px rgba(34, 197, 94, 0.4)',
                                    '&:hover': { backgroundColor: '#16a34a' },
                                }}
                            >
                                Aceptar y Cargar
                            </Button>
                        </Box>
                    </Box>
                </Dialog>

                <TelegramVerificationModal
                    open={telegramModalOpen}
                    onClose={() => setTelegramModalOpen(false)}
                    username={nombre}
                />
            </Grid>
        </Nlayout>
    )
}

export default Verificar1xBet



